import { lazy } from 'react';
import { useParams } from 'react-router-dom';
import { useReshuffleRequest } from 'src/apis/reshuffle-service/use-reshuffle-request';
import { useReshuffleServiceRoot } from 'src/apis/reshuffle-service/use-reshuffle-service';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const ReshuffleRequestDetails = () => {
  const { reshuffleRequestId } = useParams<{ reshuffleRequestId: string }>();

  const reshuffleServiceRoot = useReshuffleServiceRoot();
  const reshuffleRequest = useReshuffleRequest({
    reshuffleServiceRoot,
    reshuffleRequestId,
  });

  if (!reshuffleServiceRoot.response || !reshuffleRequest.response)
    return <PageSpinner />;

  return <Page reshuffleRequest={reshuffleRequest} />;
};
